jQuery(function($) {
    // Submit comment
    $('#commentform').submit(function(event) {
        event.preventDefault();
        var commentData = $(this).serialize() + '&action=submit_comment&nonce=' + passed.nonce;

        $.post(passed.ajax_url, commentData, function(response) {
            if (response.success) {
                $('#comment').val(''); // Clear the comment box
                fetchComments(); // Fetch new comments

				$('#comment_parent').val( '' );
				$('.replying-to').html( '' );
            } else {
                alert(response.data.message); // Show error if there's one
            }
        });
    });

    // Fetch comments every 5 seconds
    function fetchComments() {
		let user_id = $('#user_id').val();

        $.post(passed.ajax_url, {
            action: 'fetch_comments',
            post_id: passed.post_id,
            user_id: user_id,
        }, function(response) {
            if (response.success) {
                $('#comments').html(response.data.comments); // Replace comments with latest
            }
        });
    }

    // Fetch comments every 5 seconds
    function fetchPendingComments() {
        $.post(passed.ajax_url, {
            action: 'fetch_hold_comments',
            post_id: passed.post_id
        }, function(response) {
            if (response.success) {
                $('#comments-pending').html(response.data.comments); // Replace comments with latest
            }
        });
    }

    // Initial fetch and periodic updates
    fetchComments();
    fetchPendingComments();
    setInterval(fetchComments, 5000); // Poll every 5 seconds
    setInterval(fetchPendingComments, 1000); // Poll every 1 seconds

	$(document).on('click','a.delete-comment', function(e) {
		e.preventDefault();

		let comment_id = $(this).attr('data-id');

        $.post(passed.ajax_url, {
            action: 'delete_comment',
            comment_id: comment_id
        }, function(response) {
            console.log(response)
        });
	});

	$(document).on('click','a.approve-comment', function(e) {
		e.preventDefault();

		let comment_id = $(this).attr('data-id');

        $.post(passed.ajax_url, {
            action: 'approve_comment',
            comment_id: comment_id
        }, function(response) {
            console.log(response)
        });
	});

	$(document).on('click','button.comment-reply', function(e) {
		e.preventDefault();

		let comment_id    = $(this).attr('data-id');
		let comment_text  = $(this).parent().find('.comment-text').text();
		let comment_field = $('#comment');

		$('#comment_parent').val( comment_id );
		$('.replying-to').html( passed.strings.reply + ' "' + comment_text + '" <a href="#" class="cancel-reply">' + passed.strings.cancel + '</a>' )
		// comment_field.val( '"' + comment_text + '"\n\n');
		comment_field.focus();
	});

	$(document).on('click','a.cancel-reply', function(e) {
		e.preventDefault();

		$('#comment_parent').val( '' );
		$('.replying-to').html( '' )
	});

});
